import { Fragment } from "react"

type Props = {
  className?: string
  title?: string | React.ReactNode
  children?: React.ReactNode
  hasSubtitle?: boolean
  subtitle?: string
}

const PageHeader = ({
  className = "",
  title,
  children,
  hasSubtitle = false,
  subtitle = ""
}: Props) => (
  <header className={`${className} flex items-center`}>
    {!hasSubtitle && (
      <Fragment>
        <h1 className="mr-auto font-serif text-2xl">{title}</h1>
        {children}
      </Fragment>
    )}
    {hasSubtitle && (
      <div className="flex justify-between w-full">
        <div className="flex flex-col">
          <h1 className="mr-auto font-serif text-2xl">{title}</h1>
          <p className="text-sm">{subtitle}</p>
        </div>
        {children}
      </div>
    )}
  </header>
)

export default PageHeader
